export const CONTENT_CHANNEL_DESKTOP = 'desktop';
export const CONTENT_CHANNEL_MOBILE = 'mobile';

const VALID_CHANNELS = new Set([CONTENT_CHANNEL_DESKTOP, CONTENT_CHANNEL_MOBILE]);

export const normalizeContentChannel = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return VALID_CHANNELS.has(normalized) ? normalized : null;
};

const readQueryParamChannel = () => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  return normalizeContentChannel(params.get('channel'));
};

const readEnvChannel = () => normalizeContentChannel(process.env.REACT_APP_CHANNEL);

const readHostnameChannel = () => {
  if (typeof window === 'undefined') return null;
  const host = String(window.location.hostname || '').toLowerCase();
  if (!host) return null;
  if (host.startsWith('m.') || host.startsWith('mobile.')) return CONTENT_CHANNEL_MOBILE;
  return null;
};

export const resolveContentChannel = () => {
  return (
    readQueryParamChannel() ||
    readEnvChannel() ||
    readHostnameChannel() ||
    CONTENT_CHANNEL_DESKTOP
  );
};

export const getChannelContentKey = (baseKey, channel) => {
  const normalizedChannel = normalizeContentChannel(channel);
  if (!normalizedChannel) return baseKey;
  if (baseKey.endsWith(`.${normalizedChannel}`)) return baseKey;
  return `${baseKey}.${normalizedChannel}`;
};
